import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../../../../../../AppModulesWrapper';
import { selectAnalyticsProduct } from '../../../../../../../selectors/analytics';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';

import { IUsePackagesAnalytics, ITrackPackageSelectAnalyticsExtra } from '../types';

export const usePackagesAnalytics = (): IUsePackagesAnalytics => {
  const { analytics } = useAppContext();

  const product = useSelector(selectAnalyticsProduct);

  const trackPackageSelect = useCallback(
    (packageServiceId: EServiceId) => {
      analytics.send<ITrackPackageSelectAnalyticsExtra>({
        action: 'Click',
        label: 'publication_pack',
        products: [product],
        extra: {
          type: 'fvu_newest_webview',
          publication_type: packageServiceId,
        },
      });
    },
    [analytics, product],
  );

  return { trackPackageSelect };
};
